import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { UriModule } from '®shared/url-utils';

import { InlineNoteComponent } from './inline-note.component';

@NgModule({
  imports: [CommonModule, TooltipModule, UriModule],
  declarations: [InlineNoteComponent],
  exports: [InlineNoteComponent],
})
export class InlineNoteModule {}
